/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Editor_Badge_ShortageInputs */

const vi_packaging_editor_badge_shortage = /** @type {(inputs: Packaging_Editor_Badge_ShortageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu`)
};

/**

* @param {Packaging_Editor_Badge_ShortageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_editor_badge_shortage = /** @type {((inputs?: Packaging_Editor_Badge_ShortageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Editor_Badge_ShortageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_editor_badge_shortage(inputs)
});